import { api } from '@/core/api/'

const rrhhApiUrl = 'api/rrhh'

export default {  
  getRrhhInitFilters() {
    return api.get(`${rrhhApiUrl}/initfiltersrrhhreport`)
  },
  getAssistants(academicYearId, schoolId) {
    return api.get(`${rrhhApiUrl}/assistants/${academicYearId}/${schoolId}`)
  },
  getTeachers(academicYearId, schoolId) {
    return api.get(`${rrhhApiUrl}/teachers/${academicYearId}/${schoolId}`)
  },
  getReport(params) {
    return api.get(`${rrhhApiUrl}/report`, {
      params: {
          ...params
      }
    })
  }

  
}
